import { get } from '../http';

const TRANSFERWISE_API = '/api/transferwise';

const headers = {
  Accept: 'application/json',
};

const getBanks = async (countryCode) => {
  return get(`${TRANSFERWISE_API}/banks?country=${countryCode}`, { headers });
};

const getBankBranches = async (countryCode, bankCode) => {
  return get(`${TRANSFERWISE_API}/bank-branches?country=${countryCode}&bankCode=${bankCode}`, {
    headers,
  });
};

const getRegions = async (currencyCode) => {
  return get(
    `${TRANSFERWISE_API}/account-requirements?source=EUR&target=${currencyCode}&sourceAmount=1000`,
    { headers }
  );
};

const getStates = async (countryCode) => {
  return get(`${TRANSFERWISE_API}/countries/${countryCode}/states`, { headers });
};

const validateIban = async (iban) => {
  return get(`${TRANSFERWISE_API}/validators/iban?iban=${iban}`, { headers });
};

const validateIfsc = async (ifsc) => {
  return get(`${TRANSFERWISE_API}/validators/ifsc-code?ifscCode=${ifsc}`, { headers });
};

const validateIndianAccountNumber = async (accountNumber) => {
  return get(
    `${TRANSFERWISE_API}/validators/indian-account-number?accountNumber=${accountNumber}`,
    { headers }
  );
};

const TransferWiseController = {
  getBanks,
  getBankBranches,
  getRegions,
  getStates,
  validateIban,
  validateIfsc,
  validateIndianAccountNumber,
};

export default TransferWiseController;
